export default function () {
	//Přidává třídu k logu ne výpisu inzerátů dle poměru stran obrázku
	document.addEventListener("DOMContentLoaded", function () {
		document.querySelectorAll(".logo-cont img").forEach(img => {
			function checkImage() {
				if (img.naturalWidth > img.naturalHeight) {
					img.parentElement.classList.remove("tall");
					img.parentElement.classList.add("wide");
				} else {
					img.parentElement.classList.remove("wide");
					img.parentElement.classList.add("tall");
				}
			}

			if (img.complete) {
				checkImage(); // Obrázek už je načtený → rovnou ho zpracujeme
			} else {
				img.onload = checkImage; // Pro obrázky, které se ještě načítají
			}
		});
	});
}
